const recoveryTimestampKey = 'fs_chunk_recovery_at'
const recoveryCooldownMs = 60_000

export function isChunkLoadError(value: unknown): boolean {
  const message =
    value instanceof Error
      ? value.message
      : typeof value === 'string'
        ? value
        : ''

  return /failed to fetch dynamically imported module|loading chunk .* failed|importing a module script failed/i.test(
    message,
  )
}

function reloadOnce() {
  const now = Date.now()
  const previous = Number(
    window.sessionStorage.getItem(recoveryTimestampKey) ?? 0,
  )
  if (now - previous < recoveryCooldownMs) return

  window.sessionStorage.setItem(recoveryTimestampKey, String(now))
  window.location.reload()
}

/** Recover once when a rolling deployment leaves an open tab on stale chunks. */
export function installChunkLoadRecovery() {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnce()
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) return
    event.preventDefault()
    reloadOnce()
  })
}
